"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_LAYOUTS = 'LOAD_LAYOUTS';
exports.LOAD_LAYOUT = 'LOAD_LAYOUT';
exports.CREATE_LAYOUT = 'CREATE_LAYOUT';
exports.UPDATE_LAYOUT = 'UPDATE_LAYOUT';
exports.PUBLISH_LAYOUT = 'PUBLISH_LAYOUT';
exports.DELETE_LAYOUT = 'DELETE_LAYOUT';
exports.UNPUBLISH_LAYOUT = 'UNPUBLISH_LAYOUT';
exports.ADD_LAYOUT_PERMISSION = 'ADD_LAYOUT_PERMISSION';
exports.REMOVE_LAYOUT_PERMISSION = 'REMOVE_LAYOUT_PERMISSION';
exports.SET_LAYOUT_ACCESSIBILITY = 'SET_LAYOUT_ACCESSIBILITY';
exports.SET_LAYOUT_ORGANIZATION = 'SET_LAYOUT_ORGANIZATION';
exports.ADD_LAYOUT_RELATION = 'ADD_LAYOUT_RELATION';
exports.REMOVE_LAYOUT_RELATION = 'REMOVE_LAYOUT_RELATION';
exports.LOAD_PUBLIC_LAYOUTS = 'LOAD_PUBLIC_LAYOUTS';
exports.LOAD_PUBLIC_LAYOUT = 'LOAD_PUBLIC_LAYOUT';
exports.LOAD_PAGES = 'LOAD_PAGES';
exports.LOAD_PAGE = 'LOAD_PAGE';
exports.CREATE_PAGE = 'CREATE_PAGE';
exports.UPDATE_PAGE = 'UPDATE_PAGE';
exports.DELETE_PAGE = 'DELETE_PAGE';
exports.SELECT_PAGE = 'SELECT_PAGE';
exports.PUBLISH_PAGE = 'PUBLISH_PAGE';
exports.UNPUBLISH_PAGE = 'UNPUBLISH_PAGE';
exports.ADD_PAGE_PERMISSION = 'ADD_PAGE_PERMISSION';
exports.REMOVE_PAGE_PERMISSION = 'REMOVE_PAGE_PERMISSION';
exports.SET_PAGE_ACCESSIBILITY = 'SET_PAGE_ACCESSIBILITY';
exports.SET_PAGE_ORGANIZATION = 'SET_PAGE_ORGANIZATION';
exports.ADD_PAGE_RELATION = 'ADD_PAGE_RELATION';
exports.REMOVE_PAGE_RELATION = 'REMOVE_PAGE_RELATION';
exports.LOAD_PUBLIC_PAGES = 'LOAD_PUBLIC_PAGES';
exports.LOAD_PUBLIC_PAGE = 'LOAD_PUBLIC_PAGE';
exports.LOAD_POSTS = 'LOAD_POSTS';
exports.LOAD_POST = 'LOAD_POST';
exports.CREATE_POST = 'CREATE_POST';
exports.UPDATE_POST = 'UPDATE_POST';
exports.DELETE_POST = 'DELETE_POST';
exports.PUBLISH_POST = 'PUBLISH_POST';
exports.UNPUBLISH_POST = 'UNPUBLISH_POST';
exports.ADD_POST_PERMISSION = 'ADD_POST_PERMISSION';
exports.REMOVE_POST_PERMISSION = 'REMOVE_POST_PERMISSION';
exports.SET_POST_ACCESSIBILITY = 'SET_POST_ACCESSIBILITY';
exports.SET_POST_ORGANIZATION = 'SET_POST_ORGANIZATION';
exports.ADD_POST_RELATION = 'ADD_POST_RELATION';
exports.REMOVE_POST_RELATION = 'REMOVE_POST_RELATION';
exports.LOAD_PUBLIC_POSTS = 'LOAD_PUBLIC_POSTS';
exports.LOAD_PUBLIC_POST = 'LOAD_PUBLIC_POST';
exports.LOAD_THEMES = 'LOAD_THEMES';
exports.LOAD_THEME = 'LOAD_THEME';
exports.CREATE_THEME = 'CREATE_THEME';
exports.UPDATE_THEME = 'UPDATE_THEME';
exports.DELETE_THEME = 'DELETE_THEME';
exports.ADD_THEME_PERMISSION = 'ADD_THEME_PERMISSION';
exports.REMOVE_THEME_PERMISSION = 'REMOVE_THEME_PERMISSION';
exports.SET_THEME_ACCESSIBILITY = 'SET_THEME_ACCESSIBILITY';
exports.SET_THEME_ORGANIZATION = 'SET_THEME_ORGANIZATION';
exports.ADD_THEME_RELATION = 'ADD_THEME_RELATION';
exports.REMOVE_THEME_RELATION = 'REMOVE_THEME_RELATION';
exports.LOAD_PUBLIC_THEMES = 'LOAD_PUBLIC_THEMES';
exports.LOAD_PUBLIC_THEME = 'LOAD_PUBLIC_THEME';
exports.LOAD_TEXTS = 'LOAD_TEXTS';
exports.LOAD_TEXT = 'LOAD_TEXT';
exports.CREATE_TEXT = 'CREATE_TEXT';
exports.UPDATE_TEXT = 'UPDATE_TEXT';
exports.DELETE_TEXT = 'DELETE_TEXT';
exports.ADD_TEXT_PERMISSION = 'ADD_TEXT_PERMISSION';
exports.REMOVE_TEXT_PERMISSION = 'REMOVE_TEXT_PERMISSION';
exports.SET_TEXT_ACCESSIBILITY = 'SET_TEXT_ACCESSIBILITY';
exports.SET_TEXT_ORGANIZATION = 'SET_TEXT_ORGANIZATION';
exports.ADD_TEXT_RELATION = 'ADD_TEXT_RELATION';
exports.REMOVE_TEXT_RELATION = 'REMOVE_TEXT_RELATION';
exports.LOAD_PUBLIC_TEXTS = 'LOAD_PUBLIC_TEXTS';
exports.LOAD_PUBLIC_TEXT = 'LOAD_PUBLIC_TEXT';